export default function sendGtmEvent(event, params) {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push(Object.assign({ event: event }, params));
  }
};
